import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import ColumnLayoutItemViewModel from '@/ViewModels/Controls/ColumnLayoutItemViewModel';
import ColumnLayoutItem from '@/Controls/ColumnLayoutItem';

/**
 * Das ViewModel für ColumnLayoutRow
 */
export default class ColumnLayoutRowViewModel extends ControlViewModel {
    private ColumnLayoutItemViewModel = ComponentManager.getViewModel<typeof ColumnLayoutItemViewModel>('ColumnLayoutItemViewModel');

    /**
     * Die Factory-Tuples
     */
    public tuples: Array<any>;

    /**
     * Die Anzahl der Spalten pro Zeile
     */
    public columnsPerRow: number;

    /**
     * Beinhaltet und verändert die Breite der LabelColumn
     */
    public labelColumnWidth: KnockoutObservable<number | string>;

    /**
     * Die ColumnLayoutItems
     */
    public items: KnockoutComputed<Array<ColumnLayoutItem>>;

    /**
     * Gibt an, ob die Zeile sichtbar ist
     */
    public isVisible: KnockoutComputed<boolean>;

    /**
     * Das ViewModel für die ColumnLayoutRow
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.tuples = this.paramOrDefault(params.tuples, []);
        this.columnsPerRow = this.paramOrDefault(params.columnsPerRow, 1);
        this.labelColumnWidth = this.observableOrDefault(params.labelColumnWidth, 200);
        this.items = this.defineComputed(() => {
            let columnsPerRow = this.columnsPerRow;
            let tuples = this.tuples;
            let result = [];

            if (columnsPerRow > 1 && tuples.length === 1 && tuples[0].factory && tuples[0].factory.colspan === "Fill") {
                columnsPerRow = 1;
            }

            for (let i = 0; i < columnsPerRow; i++) {
                let item = new this.ColumnLayoutItemViewModel({
                    tuple: tuples[i],
                    labelColumnWidth: this.labelColumnWidth
                });

                result.push(item);
            }

            return result;
        });

        this.isVisible = this.defineComputed(() => {
            let items = this.items();
            let visibleItem = _.find(items, (item: any) => {
                return item.isVisible();
            })

            return visibleItem != null;
        });
    }
}

ComponentManager.setViewModel('ColumnLayoutRowViewModel', ColumnLayoutRowViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');